import { Navigation } from '@taxdown/piccolo-web';
import EventService from 'Services/events';
import useTranslation from 'Hooks/useTranslation';
import { ValidationSubmitProps } from './types';
import * as Styled from './styles';

const ValidationSubmit = ({
  submitLabel,
  testID,
  disabled,
  onNextScreen,
  onPrevScreen,
  isTrackForm,
  screen,
  data,
}: ValidationSubmitProps): JSX.Element => {
  const { t } = useTranslation();
  const handleOnClick = (): void => {
    if (isTrackForm) {
      const values = data?.map(item => {
        const dataForm = {
          infoValues: {
            label: item.getLabel(),
            data: item.getRenderValue(),
          },
        };
        return dataForm;
      });
      EventService.formSubmitted({
        screenId: screen?.getId(),
        values,
      });
    }
    onNextScreen();
  };

  return (
    <Styled.ContentBottom fullWidth justify="center" id="sumbit-content">
      <Styled.ButtonsContainer align="center" justify="center" fullWidth>
        <Navigation.BottomNav
          forwardButton={{
            label: t(submitLabel ?? 'Button.continue'),
            onClick: handleOnClick,
            disabled,
            testID,
          }}
          iconButton={{
            onClick: () => onPrevScreen?.(),
          }}
        />
      </Styled.ButtonsContainer>
    </Styled.ContentBottom>
  );
};

export default ValidationSubmit;
